import React, { useState } from 'react';

import CheckboxItem from './checkboxItem';

const CheckboxWithChild = (props) => {
  const { onChange, options, value: pVal, readonly } = props;
  const [value, setValue] = useState<any[]>(pVal || []);

  const onComponentChange = (item) => {
    if (value && Array.isArray(value)) {
      let isExistIndex = -1; // value是否存在当前item对象

      if (value.length === 0) {
        item.checked && value.push(item);
      } else {
        value.forEach((val, index) => {
          if (val.name === item.name) {
            isExistIndex = index;
          }
        });

        if (isExistIndex === -1) {
          value.push(item);
        } else if (item.checked) {
          value.splice(isExistIndex, 1, item);
        } else {
          value.splice(isExistIndex, 1);
        }
      }
    } else {
      console.error('value数据类型有误需要数组', value);
    }

    setValue(value);
    onChange(value);
  };

  const bindData = (item) => {
    const { value: bVal, defaultValue } = props;
    if (bVal && Array.isArray(bVal) && bVal.length) {
      bVal.forEach((bItem) => {
        if (bItem.name === item.name) {
          item.checked = bItem.checked;
          item.defaultValue = bItem.children;
        }
      });
    } else if (defaultValue && Array.isArray(defaultValue) && defaultValue.length) {
      defaultValue.forEach((bItem) => {
        if (bItem.name === item.name) {
          item.checked = bItem.checked;
          item.defaultValue = bItem.children;
        }
      });
    }

    return item;
  };

  return (
    <>
      {
        options && Array.isArray(options) && options.length > 0 && options.map((item, index) => {
          const lItem = bindData(item);
          return (
            <CheckboxItem
              {...lItem}
              disabled={!!readonly}
              key={`item_${index}`}
              onChange={(data) => onComponentChange(data)}
            />
          );
        })
      }
    </>
  );
};

export default CheckboxWithChild;
